import { observable } from 'mobx';

export interface OnlineApplicationInitialCostArgs {
  id: number;
  online_application_id?: number;
  name: string;
  plan_id: number;
  price: number;
  created_at?: string;
  updated_at?: string;
}

export class OnlineApplicationInitialCost {
  @observable id: number;
  @observable onlineApplicationId?: number;
  @observable name: string;
  @observable planId: number;
  @observable price: number;
  @observable createdAt?: string;
  @observable updatedAt?: string;

  constructor(args: Partial<OnlineApplicationInitialCostArgs> = {}) {
    this.id = args.id || 0;
    this.onlineApplicationId = args.online_application_id;
    this.name = args.name || '初期費用';
    this.planId = args.plan_id || 1;
    this.price = args.price || 0;
    this.createdAt = args.created_at;
    this.updatedAt = args.updated_at;
  }
}

export default OnlineApplicationInitialCost;
